export default __webpack_public_path__ + "static/media/FAC6.c41c7415.jpg";